import React, { useEffect } from 'react';
import { useGate, useStore } from 'effector-react';
import { formatSize } from 'pano-utils';
import { LibApiType, type LibItemMedia, LibType } from '@types';
import { queryClient, queryKeys } from '@queryClient';
import Title from '@components/Title';
import Button from '@components/Button';
import SearchBar from '../components/SearchBar';
import FooterClear from '../components/FooterClear';
import LibModalNav from '../layouts/LibModalNav';
import LibModalSpace from '../layouts/LibModalSpace';
import LibModal from '../layouts/LibModal';
import { LibItemsGate, LibMultipleGate } from '../stores/libState';
import libReset from '../actions/libReset';
import { $libSelected } from '../stores/libSelected';
import LibModalNavTip from '../layouts/LibModalNavTip';
import { LIB_SIZE_LIMIT } from '../constants';
import UploadButtonMedia from '../components/UploadButtonMedia';
import { useLibRecent } from '../utils/libRecent';
import ListDoc from './ListDoc';

type Props = {
  multiple?: boolean;
  onConfirm: (result: { libItems?: LibItemMedia[] }) => void;
  onRequestClose: () => void;
};

function LibDocModal({ multiple = false, onConfirm, onRequestClose }: Props) {
  useLibRecent('LibDocModal', '');
  useGate(LibMultipleGate, multiple);
  useEffect(() => libReset, []);
  const noSelected = !useStore($libSelected).length;

  const handleConfirm = () => {
    const selected = $libSelected.getState();
    const items = (LibItemsGate.state.getState() as LibItemMedia[])
      .filter((x) => selected.includes(x.id))
      .sort((a, b) => selected.indexOf(a.id) - selected.indexOf(b.id));
    onConfirm({ libItems: items });
  };

  return (
    <LibModal
      header={
        <>
          <Title>PDF素材库</Title>
          <SearchBar />
          <UploadButtonMedia
            className="ml-auto"
            libApiType={LibApiType.doc}
            onUploadDone={() => {
              queryClient.refetchQueries([queryKeys.libListDoc, 'items']);
            }}
          />
        </>
      }
      footer={
        <>
          <Button disabled={noSelected} onClick={handleConfirm}>
            确认操作
          </Button>
          <FooterClear />
        </>
      }
      onRequestClose={onRequestClose}
    >
      <LibModalNav
        navItems={[{ id: 'lib', name: '自定义素材' }] as const}
        selected="lib"
      >
        <LibModalSpace />
        <LibModalNavTip>
          <p>格式：.pdf PDF文件</p>
          <p>{`容量：单PDF不超过${formatSize(LIB_SIZE_LIMIT[LibType.doc])}`}</p>
        </LibModalNavTip>
      </LibModalNav>
      <ListDoc />
    </LibModal>
  );
}

export default LibDocModal;
